export default __webpack_public_path__ + "static/media/social-media.a7978385.jpg";